import { render } from "./SocialShares.vue?vue&type=template&id=782202ec&scoped=true"
import script from "./SocialShares.vue?vue&type=script&lang=js"
export * from "./SocialShares.vue?vue&type=script&lang=js"

import "./SocialShares.vue?vue&type=style&index=0&id=782202ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782202ec"]])

export default __exports__